import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Settings from './Settings';
function CalendarSettings(props) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(Settings, Object.assign({}, props))));
}
export default CalendarSettings;
